// Renders the active toasts from toastStore. Mounted once at the app root.
import { useToastStore } from '../store/toastStore'
import styles from './Toaster.module.css'

export default function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  return (
    <div className={styles.wrap}>
      {toasts.map((t) => (
        <div key={t.id} className={`${styles.toast} ${styles[t.type] || ''}`}>
          {t.message}
        </div>
      ))}
    </div>
  )
}
